// Canonical presentation geometry for every playable system. Framebuffer
// dimensions remain core-owned; these ratios describe how those pixels should
// appear everywhere RetroPlay presents them (gameplay, replays, RetroReel, and
// server-rendered video).
//
// TV systems generally use their established 4:3 display shape. Genesis is the
// exception for the shipped replay core: ClownMDEmu reports its common NTSC
// 320x224 mode as 10:7. Handheld LCD systems use their native square-pixel
// geometry.
export const SYSTEM_DISPLAY_ASPECT = Object.freeze({
  nes: '4 / 3',
  snes: '4 / 3',
  gb: '10 / 9',
  gbc: '10 / 9',
  gba: '3 / 2',
  atari2600: '4 / 3',
  c64: '4 / 3',
  genesis: '10 / 7',
  n64: '4 / 3',
});

export function displayAspectFor(systemId) {
  return SYSTEM_DISPLAY_ASPECT[systemId] || null;
}

export function displayAspectPairFor(systemId) {
  const aspect = displayAspectFor(systemId);
  if (!aspect) return null;
  const pair = aspect.split('/').map(part => Number(part.trim()));
  return Number.isFinite(pair[0]) && pair[0] > 0 && Number.isFinite(pair[1]) && pair[1] > 0
    ? pair
    : null;
}
